<template lang="pug">
  form
    .feedback-form.form
      .form__elem
        .form-elem
          .form-elem__title Выбрать тип обращения
          .form-elem__main
            select.select(
            v-model="fields.form_type"
            )
              option(
              v-for="item in formTypes"
              :value="item.id"
              ) {{item.title}}

      .form__col-container
        .form__elem
          .form-elem(
          :class="{ 'form-elem_error' : fieldsErrors.name.value }"
          )
            .form-elem__title Имя
            .form-elem__main
              input.input.input_full(
              v-model="fields.name"
              @input="resetError('name')"
              )
        .form__elem
          .form-elem(
          :class="{ 'form-elem_error' : fieldsErrors.contacts.value }"
          )
            .form-elem__title Email или телефон
            .form-elem__main
              input.input.input_full(
              v-model="fields.contacts"
              @input="resetError('contacts')"
              )
      .form__elem
        .form-elem(
        :class="{ 'form-elem_error' : fieldsErrors.text.value }"
        )
          .form-elem__title Сообщение
          .form-elem__main
            textarea.textarea.textarea_full(
            v-model="fields.text"
            @input="resetError('text')"
            )
      .form__elem
        .form-elem
          .form-elem__main
            attach-file(
            :attachmentType="'contact_attachments'"
            :attachments="fields.attachments"
            :fieldname="'attachments'"
            @onChangeAttachments="onChangeAttachments"
            )
      .form__elem.form__elem_align-right
        .form-elem
          .form-elem__main
            button.button.button_paint-main.button_long(
            @click.prevent="onButtonClick"
            :class="{ 'loaded-button': pending }"
            )
              .button__text Отправить
          .form-elem__error(
          v-if="currentErrorMessage.length > 0"
          ) {{ currentErrorMessage }}
</template>
<script>
import { mapState, mapActions } from "vuex";
import AttachFile from "../attach-file/attach-file";
export default {
  name: "feedback-form",
  components: { AttachFile },
  data() {
    return {
      fields: {
        form_type: 1,
        name: "",
        contacts: "",
        text: "",
        attachments: [],
      },
      fieldsErrors: {
        name: {
          value: false,
          message: "Введите ваше имя",
        },
        contacts: {
          value: false,
          message: "Введите ваш email или номер телефона",
        },
        text: {
          value: false,
          message: "Введите текст сообщения",
        },
      },
      formTypes: [
        {
          id: 1,
          title: "Обращение к оператору",
        },
        {
          id: 2,
          title: "Обращение к технической поддержке системы",
        },
      ],
      currentErrorMessage: "",
      pending: false,
    };
  },
  computed: {
    ...mapState(["userData"]),
  },
  methods: {
    ...mapActions(["sendMessage"]),
    onChangeAttachments(data) {
      this.fields[data.fieldname] = data.value;
    },
    resetError(model) {
      this.fieldsErrors[model].value = false;
      this.currentErrorMessage = "";
    },
    validation() {
      let errors = [];
      let fieldsForLengthValidation = ["name", "contacts", "text"];
      fieldsForLengthValidation.forEach((item) => {
        if (this.fields[item].length === 0) {
          errors.push(item);
        }
      });
      if (errors.length > 0) {
        errors.forEach((item) => {
          this.fieldsErrors[item].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onButtonClick() {
      this.pending = true;
      if (!this.validation()) {
        return false;
      }
      this.sendMessage({
        form_type: this.fields.form_type,
        name: this.fields.name,
        contacts: this.fields.contacts,
        text: this.fields.text,
        attachments: this.fields.attachments.map((el) => el.id),
      }).then((res) => {
        this.pending = false;
        if (res.status === 200) {
          this.$root.$emit("onOpenModal", "notification", {
            title: "Успешно",
            text: "Ваше сообщение было отправлено",
          });
          this.fields.attachments = [];
          this.fields.text = "";
        } else {
          this.$root.$emit("onOpenModal", "notification", {
            title: "Ошибка",
            text: "Ваше сообщение не было отправлено",
            buttonText: "Продолжить",
          });
        }
      });
    },
  },
  mounted() {
    this.fields.name = this.userData.first_name;
    this.fields.contacts = this.userData.email;
  },
};
</script>
